import React from 'react';
import Result360Page from '../Result360Page/Result360Page';

const Result40010Page = (props) => (
  <Result360Page
    {...props}
    surveyCode="40010"
    fallbackTitle="360度診断結果"
  />
);

export default Result40010Page;
